<template>
  <div>
    <weex-image
      :src="galleryImageSrc"
      :style="imageCaptureStyle"
      class="horizontal_center"
      @click="attachFile"
      >
    </weex-image>
    <file-attach-item
      :attachFileEvent="attachFileEvent"
      file-attach-button-id="fileAttach"
      @resetAttachFileEvent="attachFileEvent=false"
      @filesAttached="filesAttached"
      :image-activity-type="imageActivityType"
    >
    </file-attach-item>
  </div>
</template>

<script>

  import { ImageResourcesUtil } from "@/utils/ImageResourcesUtil";
  import FileAttachItem from "./FileAttachItem";

  export default {
    name: "ImageCapture",
    components: { FileAttachItem },
    data: () => ({
      attachFileEvent: false
    }),
    props: {
      radius: {
        type: Number,
        default: 150
      },
      imageActivityType: {
        type: Number,
        required: false,
        default: 0x0
      },
    },

    methods: {
      attachFile() {
        this.attachFileEvent = true
      },

      filesAttached(files) {
        if (files && files.length > 0) {
          this.$emit('fileAttached', files[0]);
        }
      }
    },

    computed: {
      imageCaptureStyle() {
        const dimension = 2 * this.radius + 'px'
        const radius = this.radius + 'px'
        return { 'height': dimension, 'width': dimension, 'border-radius': radius }
      },

      galleryImageSrc() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.GALLERY_ATTACH)
      }
    }
  }

</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
